"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("../IconContainer"));
const AppleIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-apple", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20.216", height: "24", viewBox: "0 0 20.216 24", role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", d: "M19.792,18.7a13.06,13.06,0,0,1-1.29,2.32,11.749,11.749,0,0,1-1.663,2.009,3.225,3.225,0,0,1-2.136.941A5.365,5.365,0,0,1,12.73,23.5a5.663,5.663,0,0,0-2.124-.47,5.855,5.855,0,0,0-2.185.47,5.875,5.875,0,0,1-1.888.5,3.033,3.033,0,0,1-2.184-.966,12.36,12.36,0,0,1-1.739-2.08A14.393,14.393,0,0,1,.772,17.3,13.373,13.373,0,0,1,0,12.948,7.951,7.951,0,0,1,1.044,8.79,6.122,6.122,0,0,1,3.23,6.579a5.878,5.878,0,0,1,2.955-.834,6.969,6.969,0,0,1,2.285.532,7.343,7.343,0,0,0,1.813.533,10.772,10.772,0,0,0,2.011-.628A6.642,6.642,0,0,1,15.026,5.7,5.8,5.8,0,0,1,19.571,8.09a5.055,5.055,0,0,0-2.681,4.593A5.063,5.063,0,0,0,18.554,16.5a5.453,5.453,0,0,0,1.662,1.091c-.134.386-.274.757-.424,1.112ZM15.161.48a5.115,5.115,0,0,1-1.313,3.358,4.47,4.47,0,0,1-3.714,1.834,3.879,3.879,0,0,1-.027-.455A5.26,5.26,0,0,1,11.5,1.823,5.359,5.359,0,0,1,13.2.55,5.062,5.062,0,0,1,15.136,0a4.3,4.3,0,0,1,.025.48Z", fill: "currentColor", stroke: "none", role: "presentation" }))));
};
exports.AppleIcon = AppleIcon;
AppleIcon.defaultProps = {
    title: "Apple icon",
};
exports.default = AppleIcon;
//# sourceMappingURL=Apple.js.map